module.exports = __webpack_public_path__ + "img/icon-vip.cc8975d1.png";